<template>
  <div class="bg-internal internal-height  ">
    <!-- <div class="mb-6 internal-height d-flex align-center justify-center "> -->
    <div
      style="height: 150px"
      class=" row col-12 col-sm-12 d-flex justify-content-center align-items-center internal-height"
    >
      <div class="col-12 col-sm-12 text-center">
        <h2 class="text-white mb-4">
          Please select an internal test server version
        </h2>

        <button
          type="button"
          class="btn btn-lg mx-3 text-uppercase font-weight-bold"
          v-for="s in serverList"
          :key="s.key"
          :class="s.color"
          @click="setInternalServer(s.value)"
        >
          {{ s.key }}
        </button>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      serverList: [
        { key: "tw", value: "tw", color: "btn-primary" },
        { key: "pts", value: "pts", color: "btn-warning" },
        { key: "mm", value: "mm", color: "btn-success" },
        { key: "honeybearkids", value: "honeybearkids", color: "btn-info" },
        { key: "mst", value: "mst", color: "info" },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    setInternalServer(key) {
      localStorage.setItem("internal_server", key);
      this.$router.push("/login");
    },
  },
};
</script>
<style lang="scss" scoped>
.internal-height {
  min-height: 100vh;
  width: 100%;
}
.bg-internal {
  background-color: rgba(0, 0, 0, 0.87);
}
</style>
